import { DbBrokerInvoice, InvoiceRow } from '@numeo/types-core'
import { GroupedBatch } from '../components/BatchesTable'

// The server returns ISO date strings; the table (GroupedBatch) expects Date objects. The two
// shapes are otherwise identical, so we hydrate the dates and cast the invoice payload through.
export function rowToGroupedBatch(row: InvoiceRow): GroupedBatch {
    return {
        id: row.id,
        batchName: row.batchName,
        invoices: row.invoices as unknown as DbBrokerInvoice[],
        totalDue: row.totalDue,
        paidAmount: row.paidAmount,
        paidAt: row.paidAt ? new Date(row.paidAt) : undefined,
        totalLoads: row.totalLoads,
        totalAdjustments: row.totalAdjustments,
        status: row.status,
        createdAt: new Date(row.createdAt),
        updatedAt: new Date(row.updatedAt),
        carrier: row.carrier,
        billTo: row.billTo,
        pdfUrl: row.pdfUrl ?? undefined,
        isNamedBatch: row.isNamedBatch,
        submittedAt: row.submittedAt ? new Date(row.submittedAt) : undefined,
        invoiceDate: row.invoiceDate ? new Date(row.invoiceDate) : undefined,
        factoringRequested: row.factoringRequested,
        factoringDisabled: row.factoringDisabled,
        source: row.source ?? undefined,
        noteCount: row.noteCount,
        loadNoteCount: row.loadNoteCount,
        invoiceStatus: row.invoiceStatus,
        latestNote: row.latestNote,
        // Resolved by the server, which is the only side that knows whether a load pseudo-row has a real
        // invoice behind it (`brokerInvoiceId`) or is a bare load.
        primaryInvoiceId: row.primaryInvoiceId ?? '',
        rowKind: row.rowKind,
        neverSubmitted: row.neverSubmitted ?? false,
    }
}
